function noshi_butotnClick(){
  if (this.ft){
    console.log(this.ft);
    show_div.style.display = "contents";
  }else{
    console.log(this.ft);
    show_div.style.display = "none";
    
    let noshiplace_options = noshiplace.options ;
    noshiplace_options[0].selected = true;

    let noshiselect_options = noshiselect.options ;
    noshiselect_options[0].selected = true;

    noshishita.value = "";
  }  
};

/*
function ryou_butotnClick(){
  if(this.check){
    show_ryou.style.display = "contents";
  }else{
    show_ryou.style.display = "none";
    atena.value ="";
    tadashi.value ="";
  }  
};
*/

function open (){
  noshi_ft[1].checked = true;
  show_div.style.display = "contents";
};

/*
function open_ryo (){
  show_ryou.style.display = "contents";
};
*/

let noshi_ft = document.getElementsByName("noshi_ft");
let show_div = document.getElementById("show_div");
let noshi_f = document.getElementById("noshi_f");
let noshi_t = document.getElementById("noshi_t");
let noshiplace = document.getElementById("noshiplace");
let noshiselect = document.getElementById("noshiselect");
let noshishita = document.getElementById("noshishita");

/*
let at_ryousyu = document.getElementsByName("attributes[ryousyu]");
let show_ryou = document.getElementById("show_ryou");
let ryousyu_none = document.getElementById("ryousyu_none");
let ryousyu_t = document.getElementById("ryousyu_t");
let ryousyu_s = document.getElementById("ryousyu_s");
let atena = document.getElementById("atena");
let tadashi = document.getElementById("tadashi");
*/


if(noshiplace.value != "不要(おまかせ)" || noshiselect.value != "のし不要" || noshishita.value != ""){
  open();
}

/* 
if(!at_ryousyu[0].checked){
  open_ryo ();
}
*/

noshi_f.addEventListener('click', {ft: false, handleEvent: noshi_butotnClick});
noshi_t.addEventListener('click',  {ft: true, handleEvent: noshi_butotnClick});

ryousyu_none.addEventListener('click', {check: false, handleEvent: ryou_butotnClick});
ryousyu_t.addEventListener('click', {check: true, handleEvent: ryou_butotnClick});
ryousyu_s.addEventListener('click', {check: true, handleEvent: ryou_butotnClick});